import React from 'react';
import PropTypes from 'prop-types';

import Loading from '@decisiv/ui-components/lib/components/Loading';
import { P } from '@decisiv/ui-components/lib/components/Typography';

import { CREATING_PANEL } from './copy';
import { CreatingRow } from './styles';

/**
 * Shown while the create — or restore/add/update, for an existing user
 * (see CreateUserWizard/index.jsx's `resultKind`) — request is in flight.
 *
 * A single left-aligned row, unlike the success and error panels which are
 * centred — that is how the mockup draws it (Figma 787:76636).
 */
function CreatingPanel({ kind }) {
  const copy = CREATING_PANEL[kind];

  return (
    <CreatingRow>
      <Loading size="small" />
      <div>
        <P weight="semibold" style={{ margin: 0 }}>
          {copy.title}
        </P>
        <P shade={1} size="small" style={{ margin: 0 }}>
          {copy.body}
        </P>
      </div>
    </CreatingRow>
  );
}

CreatingPanel.propTypes = {
  kind: PropTypes.oneOf(['created', 'restored', 'added', 'updated']),
};

CreatingPanel.defaultProps = {
  kind: 'created',
};

export default CreatingPanel;
